export default {
    Next:0,
    Previous:1,
    GoTo:2,
}


// WEBPACK FOOTER //
// ./src/components/common/wizard/logic/stepActions.js